import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  media: {
    borderRadius: "20px",
    objectFit: "contain",
    width: "100%",
    maxHeight: "500px",
  },
  card: {
    display: "flex",
    flexDirection: "column-reverse",
    width: "100%",
    // [theme.breakpoints.down('md')]: {
    // //   flexWrap: 'wrap',
    //   flexDirection: 'column-reverse',
    // },
  },
  section: {
    borderRadius: "20px",
    margin: "10px",
    flex: 1,
    fontSize: "100%",
  },
  imageSection: {
    marginBlock: "20px",
    overflow: "hidden",
    // marginLeft: '20px',
    // [theme.breakpoints.down('md')]: {
    //   marginLeft: 0,
    // },
    // [theme.breakpoints.between('1280', 'lg')]: {
    //   width: '60%',
    // },
  },
  recommendedPosts: {
    width: "100%",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "flex-start",
    alignItems: "center",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
    },
  },
  loadingPaper: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "20px",
    borderRadius: "15px",
    height: "39vh",
  },
  singlePost: {
    width: "100%",
    margin: "20px",
    cursor: "pointer",
    maxWidth: "200px",
    padding: "10px",
    borderRadius: "5px",
    boxShadow: "0 10px 10px 3px rgba(0,0,0,0.1)",
    [theme.breakpoints.down("xs")]: {
      margin: "0px",
      marginBlock: "20px",
    },
  },
  postImg: {
    width: "100%",
    maxHeight: "200px",
    objectFit: "contain",
    borderRadius: "5px",
    marginBottom: "0.5rem",
  },
  commentsOuterContainer: {
    display: "flex",
    maxWidth: "1200px",
    justifyContent: "space-between",
    alignItems: "center",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column-reverse",
    },
  },
  commentsInnerContainer: {
    height: "200px",
    overflowY: "auto",
    marginRight: "30px",
    padding: "0.5rem 0",
    flex: "1",
    borderTop: "1px solid rgba(0,0,0,0.1)",
    borderBottom: "1px solid rgba(0,0,0,0.1)",
    [theme.breakpoints.down("xs")]: {
      marginRight: "0",
    },
  },
  commentInput: {
    width: "50%",
    [theme.breakpoints.down("xs")]: {
      width: "100%",
      marginBottom: "2rem",
    },
  },
}));
